import React, { useState, useEffect } from 'react';
import { api_contractorResumeUpdate, api_contractorResumeDetail } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { ReqResumeEdit, RespResumeDetail, ReqResumeDetail, RespResumeOtherData } from '../../../../item/ItemResume';
import moment from 'moment';
import { ContractorResumeFamily, OtherData_family } from './ContractorResumeFamily';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { ContractorResumeBase, OtherData_base } from './ContractorResumeBase';
import { ContractorResumeEducation, OtherData_education } from './ContractorResumeEducation';
import { ContractorResumeWorkExperiences, OtherData_workExperiences } from './ContractorResumeWorkExperiences';
import { ContractorResumePayrollMethod, OtherData_payrollMethod } from './ContractorResumePayrollMethod';
import { getResume2Token, getval2Token } from '../../../Login/Auth';
import { ContractorResumeAttachment, OtherData_attachment } from './ContractorResumeAttachment';

export function ContractorResumeEdit({ id, setIsLoading, isEdit=false }) {
    const [tokenId, setTokenId] = useState("")
    const [resumeId, setResumeId] = useState("")
    const [idNumber, setIdNumber] = useState("")
    const [birthday, setBirtyday] = useState("")
    const [base, setBase] = useState({})
    const [family, setFamily] = useState({})
    const [education, setEducation] = useState({})
    const [payrollMethod, setPayrollMethod] = useState({})
    const [attachment, setAttachment] = useState({})
    const [workExperiences, setWorkExperiences] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var rId = getval2Token("resumeId", id)
            // var rId = getResume2Token(id)
            setResumeId(rId)
            setTokenId(id)
            var mReqResumeDetail = new ReqResumeDetail({
                resumeId: rId,
            })
            getDetail(mReqResumeDetail)
        }
    }, [id])

    function getDetail(mReqResumeDetail) {
        setIsLoading(true)
        console.log(mReqResumeDetail)
        api_contractorResumeDetail({
            mReqResumeDetail,
            success: (result) => {
                console.log(result)
                var mRespResumeDetail = new RespResumeDetail({})
                mRespResumeDetail.fromJson(result.info)
                setResumeId(mRespResumeDetail.resumeId)
                setIdNumber(mRespResumeDetail.idNumber)
                var bDay = moment(mRespResumeDetail.birthday).format('YYYY/MM/DD')
                setBirtyday(bDay)
                //console.log(mRespResumeDetail.resumeDatas.workExperiences)
                //console.log(mRespResumeDetail.resumeDatas.attachment)
                setBase(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId, 
                    resumeKey: OtherData_base, 
                    resumeData: mRespResumeDetail.resumeDatas.base}))
                setFamily(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId, 
                    resumeKey: OtherData_family, 
                    resumeData: mRespResumeDetail.resumeDatas.family}))
                setEducation(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId, 
                    resumeKey: OtherData_education, 
                    resumeData: mRespResumeDetail.resumeDatas.education}))
                setWorkExperiences(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId, 
                    resumeKey: OtherData_workExperiences, 
                    resumeData: mRespResumeDetail.resumeDatas.workExperiences}))
                setAttachment(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId, 
                    resumeKey: OtherData_attachment, 
                    resumeData: mRespResumeDetail.resumeDatas.attachment}))                
                setPayrollMethod(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId, 
                    resumeKey: OtherData_payrollMethod, 
                    resumeData: mRespResumeDetail.resumeDatas.payrollMethod}))
                
                //setOtherData(mRespResumeDetail.otherData)
                setIsLoading(false)
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                }).then(() => {
                    window.history.go(-1)
                })
            }
        })
    }

    function setResumeOtherData({resumeId, resumeKey, resumeData}){
        if(resumeData === undefined){
            return new RespResumeOtherData({
                resumeId,
                resumeKey
            })
        }
        return resumeData
    }

    async function toSave(birthday) {
        var mReqResumeEdit = new ReqResumeEdit({
            resumeId,
            birthday
        })
        try {
            await api_contractorResumeUpdate({ mReqResumeEdit })
            console.log("OK")
        } catch (error) {
            console.log(error)
        }
    }

    function toEdit(){
        window.location.assign("/ContractorResumeEdit/" + id);
    }
    function toDetial(){
        window.location.assign("/ContractorResumeDetail/" + id);
    }

    return (
        <>
        <ContractorResumeBase
            rId={resumeId}
            idN={idNumber}
            bDay={birthday}
            base={base}
            setIsLoading={setIsLoading}
            toSave={toSave}
            toEdit={toEdit}
            isEdit={isEdit}
            toDetial={toDetial}
        />
        <ContractorResumeFamily
            rId={resumeId}
            familys={family}
            setIsLoading={setIsLoading}
            isEdit={isEdit}
            toDetial={toDetial}
        />
        <ContractorResumeEducation
            rId={resumeId}
            education={education}
            setIsLoading={setIsLoading}
            isEdit={isEdit}
            toDetial={toDetial}
        />
        <ContractorResumeWorkExperiences
            rId={resumeId}
            workExperiences={workExperiences}
            setIsLoading={setIsLoading}
            isEdit={isEdit}
            toDetial={toDetial}
        />
        <ContractorResumeAttachment 
            rId={resumeId}
            attachment={attachment}
            setIsLoading={setIsLoading}
            isEdit={isEdit}
            toDetial={toDetial}
        />
        <ContractorResumePayrollMethod
            rId={resumeId}
            payrollMethod={payrollMethod}
            setIsLoading={setIsLoading}
            isEdit={isEdit}
            toDetial={toDetial}
        />
        <ManagementPrompt />
        <SystemPromptInput />
        </>
    )
}